/** 最後尾で検索すると、各ブランドの最後尾に飛べる */
const brands = [
  {
    name: 'hoshinoya',
    title: '星のや',
    description: '圧倒的非日常感に包まれる日本発のラグジュアリーホテル',
    facilities: [
      {
        name: 'karuizawa',
        title: '星のや軽井沢',
        link: 'https://hoshinoya.com/karuizawa/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000001',
        description: '谷の集落に滞在する',
        location: '長野県・軽井沢',
        valid: true,
        coordinates: {
          pc: {
            x: '54.4%',
            y: '58.5%',
          },
          sp: {
            x: '53.4%',
            y: '57.6%',
          },
        },
      },
      {
        name: 'taketomijima',
        title: '星のや竹富島',
        link: 'https://hoshinoya.com/taketomijima/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000010',
        description: '琉球列島はるか南、珊瑚の離島',
        location: '沖縄県・八重山郡',
        valid: true,
        coordinates: {
          pc: {
            x: '3.8%',
            y: '87%',
          },
          sp: {
            x: '10.2%',
            y: '37.5%',
          },
        },
      },
      {
        name: 'kyoto',
        title: '星のや京都',
        link: 'https://hoshinoya.com/kyoto/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000007',
        description: '嵐峡の地に建つ、水辺の私邸',
        location: '京都府・嵐山',
        valid: true,
        coordinates: {
          pc: {
            x: '40.5%',
            y: '68.5%',
          },
          sp: {
            x: '31.8%',
            y: '67.6%',
          },
        },
      },
      {
        name: 'gugan',
        title: '星のやグーグァン',
        description: '台湾初のラグジュアリー温泉リゾート',
        location: '台中・谷關',
        valid: false,
      },
      {
        name: 'bali',
        title: '星のやバリ',
        description: 'バリの世界観に融和し共鳴する',
        location: 'インドネシア',
        valid: false,
      },
      {
        name: 'tokyo',
        title: '星のや東京',
        link: 'https://hoshinoya.com/tokyo/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000015',
        description: '和のおもてなしを世界に発信する日本旅館',
        location: '東京・大手町',
        valid: true,
        coordinates: {
          pc: {
            x: '57.3%',
            y: '66.7%',
          },
          sp: {
            x: '56.9%',
            y: '66.6%',
          },
        },
      },
      {
        name: 'fuji',
        title: '星のや富士',
        link: 'https://hoshinoya.com/fuji/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000014',
        description: '明日が分からない、丘陵のグランピング',
        location: '山梨県・富士河口湖',
        valid: true,
        coordinates: {
          pc: {
            x: '56.3%',
            y: '65.9%',
          },
          sp: {
            x: '52.8%',
            y: '65.8%',
          },
        },
      },
      {
        name: 'okinawa',
        title: '星のや沖縄',
        link: 'https://hoshinoya.com/okinawa/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000018',
        description: '海を眺めて暮らす贅沢',
        location: '沖縄県・読谷村',
        valid: true,
        coordinates: {
          pc: {
            x: '1%',
            y: '66%',
          },
          sp: {
            x: '5%',
            y: '11%',
          },
        },
      },
    ],
  },
  /** 星のや最後尾 */
  {
    name: 'kai',
    title: '界',
    description: '地域の魅力を再発見。心地よい和にこだわった上質な温泉旅館',
    facilities: [
      {
        name: 'anjin',
        title: '界 アンジン',
        link: 'https://hoshinoresorts.com/ja/hotels/kaianjin/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000122',
        description: 'マリンアンティークな空間で船旅気分',
        location: '静岡県・伊東温泉',
        valid: true,
        coordinates: {
          pc: {
            x: '55.4%',
            y: '71.2%',
          },
          sp: {
            x: '51.7%',
            y: '70.6%',
          },
        },
      },
      {
        name: 'kaga',
        title: '界 加賀',
        link: 'https://hoshinoresorts.com/ja/hotels/kaikaga/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000103',
        description: '新しい感性が息づく加賀伝統の温泉宿',
        location: '石川県・山代温泉',
        valid: true,
        coordinates: {
          pc: {
            x: '44.8%',
            y: '58.5%',
          },
          sp: {
            x: '37.8%',
            y: '58.2%',
          },
        },
      },
      {
        name: 'sengokuhara',
        title: '界 仙石原',
        link: 'https://hoshinoresorts.com/ja/hotels/kaisengokuhara/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000124',
        description: '内なる表現欲と出会うアトリエ温泉旅館',
        location: '神奈川県・仙石原温泉',
        valid: true,
        coordinates: {
          pc: {
            x: '55.6%',
            y: '67.4%',
          },
          sp: {
            x: '52%',
            y: '67%',
          },
        },
      },
      {
        name: 'tamatsukuri',
        title: '界 玉造',
        link: 'https://hoshinoresorts.com/ja/hotels/kaitamatsukuri/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000106',
        description: 'いにしえの湯と出雲文化を遊ぶ宿',
        location: '島根県・玉造温泉',
        valid: true,
        coordinates: {
          pc: {
            x: '29.4%',
            y: '62.4%',
          },
          sp: {
            x: '17.9%',
            y: '61.4%',
          },
        },
      },
      {
        name: 'kinugawa',
        title: '界 鬼怒川',
        link: 'https://hoshinoresorts.com/ja/hotels/kaikinugawa/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000121',
        description: 'とちぎ民藝が光る木漏れ日の湯宿',
        location: '栃木県・鬼怒川温泉',
        valid: true,
        coordinates: {
          pc: {
            x: '60.5%',
            y: '58%',
          },
          sp: {
            x: '59%',
            y: '57.5%',
          },
        },
      },
      {
        name: 'ito',
        title: '界 伊東',
        link: 'https://hoshinoresorts.com/ja/hotels/kaiito/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000108',
        description: '温泉づくし花暦の宿',
        location: '静岡県・伊東温泉',
        valid: true,
        coordinates: {
          pc: {
            x: '54.8%',
            y: '71.4%',
          },
          sp: {
            x: '50.9%',
            y: '71.3%',
          },
        },
      },
      {
        name: 'matsumoto',
        title: '界 松本',
        link: 'https://hoshinoresorts.com/ja/hotels/kaimatsumoto/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000104',
        description: '音響抜群のロビーでコンサート',
        location: '長野県・浅間温泉',
        valid: true,
        coordinates: {
          pc: {
            x: '51.6%',
            y: '62.4%',
          },
          sp: {
            x: '45.6%',
            y: '59.8%',
          },
        },
      },
      {
        name: 'enshu',
        title: '界 遠州',
        link: 'https://hoshinoresorts.com/ja/hotels/kaienshu/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000113',
        description: '湖畔に佇む宿ならではの解放感',
        location: '静岡県・舘山寺温泉',
        valid: true,
        coordinates: {
          pc: {
            x: '47.5%',
            y: '71.5%',
          },
          sp: {
            x: '42.5%',
            y: '70.5%',
          },
        },
      },
      {
        name: 'alps',
        title: '界 アルプス',
        link: 'https://hoshinoresorts.com/ja/hotels/kaialps/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000123',
        description: '信州の贅沢な田舎を体感する温泉宿',
        location: '長野県・大町温泉',
        valid: true,
        coordinates: {
          pc: {
            x: '50.8%',
            y: '60.2%',
          },
          sp: {
            x: '46.8%',
            y: '62%',
          },
        },
      },
      {
        name: 'aso',
        title: '界 阿蘇',
        link: 'https://hoshinoresorts.com/ja/hotels/kaiaso/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000115',
        description: '火の国、水の国がもたらす神仙郷',
        location: '大分県・瀬の本温泉',
        valid: true,
        coordinates: {
          pc: {
            x: '20.2%',
            y: '78.7%',
          },
          sp: {
            x: '5.5%',
            y: '78.3%',
          },
        },
      },
      {
        name: 'hakone',
        title: '界 箱根',
        link: 'https://hoshinoresorts.com/ja/hotels/kaihakone/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000117',
        description: '寄木細工のように変幻自在',
        location: '神奈川県・箱根湯本温泉',
        valid: true,
        coordinates: {
          pc: {
            x: '56.7%',
            y: '67.4%',
          },
          sp: {
            x: '53.5%',
            y: '67.1%',
          },
        },
      },
      {
        name: 'tsugaru',
        title: '界 津軽',
        link: 'https://hoshinoresorts.com/ja/hotels/kaitsugaru/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000114',
        description: '津軽三味線の迫力に包まれる',
        location: '青森県・大鰐温泉',
        valid: true,
        coordinates: {
          pc: {
            x: '64.7%',
            y: '30.5%',
          },
          sp: {
            x: '64.6%',
            y: '30.5%',
          },
        },
      },
      {
        name: 'nagato',
        title: '界 長門',
        link: 'https://hoshinoresorts.com/ja/hotels/kainagato/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000126',
        description: '「御茶屋屋敷」がテーマの温泉旅館',
        location: '山口県・長門湯本温泉',
        valid: true,
        coordinates: {
          pc: {
            x: '20.4%',
            y: '68.4%',
          },
          sp: {
            x: '8.4%',
            y: '66.9%',
          },
        },
      },
      {
        name: 'kirishima',
        title: '界 霧島',
        link: 'https://hoshinoresorts.com/ja/hotels/kaikirishima/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000127',
        description: '桜島をはるかに見渡し、湯浴み小屋でうるおう宿',
        location: '鹿児島県・霧島温泉',
        valid: true,
        coordinates: {
          pc: {
            x: '18.0%',
            y: '88.0%',
          },
          sp: {
            x: '3.5%',
            y: '88.3%',
          },
        },
      },
      {
        name: 'beppu',
        title: '界 別府',
        link: 'https://hoshinoresorts.com/ja/hotels/kaibeppu/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000128',
        description: 'ドラマティック温泉街に逗留する宿',
        location: '大分県・別府市',
        valid: true,
        coordinates: {
          pc: {
            x: '22.2%',
            y: '78.7%',
          },
          sp: {
            x: '8.5%',
            y: '78.3%',
          },
        },
      },
      {
        name: 'poroto',
        title: '界 ポロト',
        link: 'https://hoshinoresorts.com/ja/hotels/kaiporoto/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000129',
        description: 'ポロト湖の懐にひたる、とんがり湯小屋の宿',
        location: '北海道・白老町',
        valid: true,
        coordinates: {
          pc: {
            x: '68.9%',
            y: '15.2%',
          },
          sp: {
            x: '68.9%',
            y: '15.6%',
          },
        },
      },
      {
        name: 'yuhuin',
        title: '界 由布院',
        link: 'https://hoshinoresorts.com/ja/hotels/kaiyufuin/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000130/',
        description: '由布岳の麓で棚田暦に憩う宿',
        location: '大分県・由布市',
        valid: true,
        coordinates: {
          pc: {
            x: '21.5%',
            y: '79.0%',
          },
          sp: {
            x: '7.3%',
            y: '78.5%',
          },
        },
      },
      {
        name: 'unzen',
        title: '界 雲仙',
        link: 'https://hoshinoresorts.com/ja/hotels/kaiunzen/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000131/',
        description: '地獄パワーにふれる、異国情緒の宿',
        location: '長崎県・雲仙市',
        valid: true,
        coordinates: {
          pc: {
            x: '15.9%',
            y: '79.0%',
          },
          sp: {
            x: '1.0%',
            y: '78.5%',
          },
        },
      },
      {
        name: 'izumo',
        title: '界 出雲',
        link: 'https://hoshinoresorts.com/ja/hotels/kaiizumo/',
        ygetsLink: 'https://hoshinoresorts.com/#/JA/hotels/0000000132',
        description: '灯台と水平線を望む縁結び支度の宿',
        location: '島根県・出雲市',
        valid: true,
        coordinates: {
          pc: {
            x: '29.6%',
            y: '62.4%',
          },
          sp: {
            x: '18.2%',
            y: '61.4%',
          },
        },
      },
      {
        name: 'akiu',
        title: '界 秋保',
        link: 'https://hoshinoresorts.com/ja/hotels/kaiakiu/',
        ygetsLink: 'https://hoshinoresorts.com/#/JA/hotels/0000000133',
        description: '名取川の四季に浸る うるはしのひととき',
        location: '宮城県・仙台市',
        valid: true,
        coordinates: {
          pc: {
            x: '63.0%',
            y: '49.0%',
          },
          sp: {
            x: '62.5%',
            y: '48.2%',
          },
        },
      },
      {
        name: 'okuhida',
        title: '界 奥飛騨',
        link: 'https://hoshinoresorts.com/ja/hotels/kaiokuhida/',
        ygetsLink: 'https://hoshinoresorts.com/#/JA/hotels/0000000134',
        description: '山岳温泉にめざめ、飛騨デザインに寛ぐ宿',
        location: '岐阜県・高山市',
        valid: true,
        coordinates: {
          pc: {
            x: '49.6%',
            y: '62.4%',
          },
          sp: {
            x: '44.0%',
            y: '59.8%',
          },
        },
      },
      {
        name: 'atami',
        title: '界 熱海(長期休館中)',
        link: 'https://hoshinoresorts.com/ja/hotels/kaiatami/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000111',
        description: '海原を一望する空中湯上りどころ',
        location: '静岡県・伊豆山温泉',
        valid: true,
        coordinates: {
          pc: {
            x: '55.9%',
            y: '69.4%',
          },
          sp: {
            x: '52.3%',
            y: '69.7%',
          },
        },
      },
      {
        name: 'nikko',
        title: '界 日光(長期休館中)',
        link: 'https://hoshinoresorts.com/ja/hotels/kainikko/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000118',
        description: '中禅寺湖の神秘にため息',
        location: '栃木県・中禅寺温泉',
        valid: true,
        coordinates: {
          pc: {
            x: '59%',
            y: '59%',
          },
          sp: {
            x: '57%',
            y: '58%',
          },
        },
      },
    ],
  },
  /** 界最後尾 */
  {
    name: 'risonare',
    title: 'リゾナーレ',
    description:
      '洗練されたデザインと豊富なアクティビティをそなえる西洋型リゾート',
    facilities: [
      {
        name: 'tomamu',
        title: 'リゾナーレトマム',
        link: 'https://risonare.com/tomamu/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/1000000006',
        description: '蒼き森の奥に佇む優雅な空間',
        location: '北海道・勇払郡',
        valid: true,
        coordinates: {
          pc: {
            x: '77%',
            y: '12.7%',
          },
          sp: {
            x: '81%',
            y: '12.9%',
          },
        },
      },
      {
        name: 'atami',
        title: 'リゾナーレ熱海',
        link: 'https://risonare.com/atami/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000011',
        description: '大海原と夜景を見下ろす特等席',
        location: '静岡県・熱海市',
        valid: true,
        coordinates: {
          pc: {
            x: '54.8%',
            y: '69.2%',
          },
          sp: {
            x: '51.1%',
            y: '69%',
          },
        },
      },
      {
        name: 'yatsugatake',
        title: 'リゾナーレ八ヶ岳',
        link: 'https://risonare.com/yatsugatake/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000003',
        description: '八ヶ岳高原にヨーロッパの町並み',
        location: '山梨県・北杜市',
        valid: true,
        coordinates: {
          pc: {
            x: '53.2%',
            y: '63.9%',
          },
          sp: {
            x: '48.7%',
            y: '63.6%',
          },
        },
      },
      {
        name: 'nasu',
        title: 'リゾナーレ那須',
        link: 'https://risonare.com/nasu/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000017',
        description: '童心に帰る、高原のアグリツーリズモリゾート',
        location: '栃木県・那須郡',
        valid: true,
        coordinates: {
          pc: {
            x: '58.5%',
            y: '54.58%',
          },
          sp: {
            x: '58%',
            y: '55%',
          },
        },
      },
      {
        name: 'kohamajima',
        title: 'リゾナーレ小浜島',
        link: 'https://risonare.com/kohamajima/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000016',
        description: '離島を満喫する海辺のリゾート',
        location: '沖縄県・小浜島',
        valid: true,
        coordinates: {
          pc: {
            x: '2.8%',
            y: '87%',
          },
          sp: {
            x: '8.2%',
            y: '37.5%',
          },
        },
      },
    ],
  },
  /** リゾナーレ最後尾 */
  {
    name: 'omo',
    title: 'OMO',
    description: '旅のテンションを上げ、街を楽しみ尽くす観光客のためのホテル',
    facilities: [
      {
        name: 'asahikawa',
        title: 'OMO7旭川',
        link: 'https://omo-hotels.com/asahikawa/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000201',
        description: 'たくさんの物語と街が調和するホテル',
        location: '北海道・旭川市',
        valid: true,
        coordinates: {
          pc: {
            x: '74.5%',
            y: '8.8%',
          },
          sp: {
            x: '76.7%',
            y: '9.1%',
          },
        },
      },
      {
        name: 'otsuka',
        title: 'OMO5東京大塚',
        link: 'https://omo-hotels.com/otsuka/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000302',
        description: '路面電車のベルに心温まるレトロ東京',
        location: '東京・大塚',
        valid: true,
        coordinates: {
          pc: {
            x: '59.3%',
            y: '65.3%',
          },
          sp: {
            x: '56.9%',
            y: '65.1%',
          },
        },
      },
      {
        name: 'osaka',
        title: 'OMO7大阪',
        link: 'https://hoshinoresorts.com/ja/hotels/omo7osaka/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000310/',
        description: 'ほれてまうわ、なにわ',
        location: '大阪府・大阪市',
        valid: true,
        coordinates: {
          pc: {
            x: '39.5%',
            y: '70.5%',
          },
          sp: {
            x: '30.3%',
            y: '69.1%',
          },
        },
      },
      {
        name: 'gion',
        title: 'OMO5京都祇園',
        link: 'https://hoshinoresorts.com/ja/hotels/omo5kyotogion/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000305/',
        description: '今日は祇園ぐらし',
        location: '京都府・東山区',
        valid: true,
        coordinates: {
          pc: {
            x: '59.3%',
            y: '65.3%',
          },
          sp: {
            x: '56.9%',
            y: '65.1%',
          },
        },
      },
      {
        name: 'naha',
        title: 'OMO5沖縄那覇',
        link: 'https://hoshinoresorts.com/ja/hotels/omo5okinawanaha/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000304',
        description: 'バザールって、ちむどんどん♬',
        location: '沖縄県・那覇市',
        valid: true,
        coordinates: {
          pc: {
            x: '1%',
            y: '70%',
          },
          sp: {
            x: '4%',
            y: '18%',
          },
        },
      },
      {
        name: 'otaru',
        title: 'OMO5小樽',
        link: 'https://hoshinoresorts.com/ja/hotels/omo5otaru/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000309/',
        description: 'ソーラン、目覚めの港町',
        location: '北海道・小樽市',
        valid: true,
        coordinates: {
          pc: {
            x: '70.0%',
            y: '11.5%',
          },
          sp: {
            x: '72.0%',
            y: '11.4%',
          },
        },
      },
      {
        name: 'susukino',
        title: 'OMO3札幌すすきの',
        link: 'https://hoshinoresorts.com/ja/hotels/omo3sapporosusukino/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000308/',
        description: '幸せな夜更かし',
        location: '北海道・札幌すすきの',
        valid: true,
        coordinates: {
          pc: {
            x: '70.9%',
            y: '11.7%',
          },
          sp: {
            x: '72.4%',
            y: '11.6%',
          },
        },
      },
      {
        name: 'hakodate',
        title: 'OMO5函館',
        link: 'https://hoshinoresorts.com/ja/hotels/omo5hakodate/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000318',
        description: '百二十％ハコダテ',
        location: '北海道・函館市',
        valid: true,
        coordinates: {
          pc: {
            x: '66.0%',
            y: '20.2%',
          },
          sp: {
            x: '67.0%',
            y: '20.5%',
          },
        },
      },
      {
        name: 'gotanda',
        title: 'OMO5東京五反田',
        link: 'https://hoshinoresorts.com/ja/hotels/omo5tokyogotanda/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000317/',
        description: '夜景とご馳走のパラダイス',
        location: '東京・五反田',
        valid: true,
        coordinates: {
          pc: {
            x: '59.3%',
            y: '65.5%',
          },
          sp: {
            x: '56.9%',
            y: '65.3%',
          },
        },
      },
      {
        name: 'akasaka',
        title: 'OMO3東京赤坂',
        link: 'https://hoshinoresorts.com/ja/hotels/omo3tokyoakasaka/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000307/',
        description: 'イイとこみっけ',
        location: '東京・赤坂',
        valid: true,
        coordinates: {
          pc: {
            x: '59.3%',
            y: '65.8%',
          },
          sp: {
            x: '56.9%',
            y: '65.5%',
          },
        },
      },
      {
        name: 'asakusa',
        title: 'OMO3浅草',
        link: 'https://hoshinoresorts.com/ja/hotels/omo3asakusa/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000316/',
        description: '粋だねぇ、浅草上手',
        location: '東京・浅草',
        valid: true,
        coordinates: {
          pc: {
            x: '59.8%',
            y: '64.8%',
          },
          sp: {
            x: '57.7%',
            y: '64.5%',
          },
        },
      },
      {
        name: 'katamachi',
        title: 'OMO5金沢片町',
        link: 'https://hoshinoresorts.com/ja/hotels/omo5kanazawakatamachi/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000311/',
        description: 'あっぱれ！味のかたまち',
        location: '石川県・金沢市',
        valid: true,
        coordinates: {
          pc: {
            x: '45.8%',
            y: '58.5%',
          },
          sp: {
            x: '38.8%',
            y: '58.2%',
          },
        },
      },
      {
        name: 'sanjo',
        title: 'OMO5京都三条',
        link: 'https://hoshinoresorts.com/ja/hotels/omo5kyotosanjo/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000306',
        description: '京町らんまん川歩き',
        location: '京都府・中京区',
        valid: true,
        coordinates: {
          pc: {
            x: '41.5%',
            y: '68.5%',
          },
          sp: {
            x: '33.8%',
            y: '67.6%',
          },
        },
      },
      /*
        {
          name: 'kawasaki',
          title: 'OMO3東京川崎',
          link: 'https://hoshinoresorts.com/ja/hotels/omo3tokyokawasaki/',
          ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000303',
          description: 'ふらっと東京旅。 旅の拠点は、OMO（おも）がいい。',
          location: '神奈川県・川崎',
          valid: true,
          coordinates: {
            pc: {
              x: '56.9%',
              y: '68.3%'
            },
            sp: {
              x: '54%',
              y: '68%'
            }
          }
        }
      */
      {
        name: 'toji',
        title: 'OMO3京都東寺',
        link: 'https://hoshinoresorts.com/ja/hotels/omo3kyototoji/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000312/',
        description: '心の時空トリップ',
        location: '京都府・南区',
        valid: true,
        coordinates: {
          pc: {
            x: '40.5%',
            y: '69.5%',
          },
          sp: {
            x: '31.8%',
            y: '69.6%',
          },
        },
      },
      {
        name: 'kansaikukou',
        title: 'OMO関西空港',
        link: 'https://hoshinoresorts.com/ja/hotels/omokansaiairport/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000313/',
        description: '空チカ、ファンタイム',
        location: '大阪府・泉佐野市',
        valid: true,
        coordinates: {
          pc: {
            x: '38.0%',
            y: '72.1%',
          },
          sp: {
            x: '30.2%',
            y: '71.2%',
          },
        },
      },
      {
        name: 'kochi',
        title: 'OMO7高知',
        link: 'https://hoshinoresorts.com/ja/hotels/omo7kochi/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000315/',
        description: '歴史と活気を感じる街、高知',
        location: '高知県・高知市',
        valid: true,
        coordinates: {
          pc: {
            x: '29.8%',
            y: '76.9%',
          },
          sp: {
            x: '19.4%',
            y: '75.7%',
          },
        },
      },
      {
        name: 'kumamoto',
        title: 'OMO5熊本',
        link: 'https://hoshinoresorts.com/ja/hotels/omo5kumamoto/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000314/',
        description: 'わさラッシュ！城下マチ',
        location: '熊本県・熊本市',
        valid: true,
        coordinates: {
          pc: {
            x: '18.0%',
            y: '79.5%',
          },
          sp: {
            x: '3.3%',
            y: '78.8%',
          },
        },
      },
    ],
  },
  /** OMO最後尾 */
  {
    name: 'beb',
    title: 'BEB',
    description: '「居酒屋以上 旅未満」仲間とルーズに過ごすホテル',
    facilities: [
      {
        name: 'bebkaruizawa',
        title: 'BEB5軽井沢',
        link: 'https://hoshinoresorts.com/ja/hotels/beb5karuizawa/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000202',
        description:
          '背伸びせず自由に！気の合うアイツん家のように「ルーズ」なホテル',
        location: '長野県・軽井沢',
        valid: true,
        coordinates: {
          pc: {
            x: '53.6%',
            y: '60.9%',
          },
          sp: {
            x: '49.2%',
            y: '61.7%',
          },
        },
      },
      {
        name: 'bebtsuchiura',
        title: 'BEB5土浦',
        link: 'https://hoshinoresorts.com/ja/hotels/beb5tsuchiura/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000203',
        description: '駅の改札前が入口の、ちょっとルーズなホテル',
        location: '茨城県・土浦市',
        valid: true,
        coordinates: {
          pc: {
            x: '60.3%',
            y: '62.3%',
          },
          sp: {
            x: '60.3%',
            y: '62.3%',
          },
        },
      },
      {
        name: 'seragaki',
        title: 'BEB5沖縄瀬良垣',
        link: 'https://hoshinoresorts.com/ja/hotels/beb5okinawaseragaki/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000204/',
        description:
          'みんながゆったり（よんな〜）沖縄時間を過ごせるルーズなホテル',
        location: '沖縄県・恩納村',
        valid: true,
        coordinates: {
          pc: {
            x: '1%',
            y: '69%',
          },
          sp: {
            x: '4%',
            y: '17%',
          },
        },
      },
    ],
  },
  /** BEB最後尾 */
  {
    name: 'other',
    title: 'そのほかの個性的な宿泊施設',
    description: '日本全国に展開する個性際立つリゾートホテルや温泉旅館',
    facilities: [
      {
        name: 'snowtomamu',
        title: 'トマム ザ・タワー',
        link: 'https://www.snowtomamu.jp/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000006',
        description: 'エゾシカが跳ねる雄大なリゾート',
        location: '北海道・勇払郡',
        valid: true,
        coordinates: {
          pc: {
            x: '75.9%',
            y: '12.7%',
          },
          sp: {
            x: '79.4%',
            y: '12.6%',
          },
        },
      },
      {
        name: 'oirase',
        title: '奥入瀬渓流ホテル',
        link: 'https://www.oirase-keiryuu.jp/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000102',
        description: '阿修羅の流れが躍動する',
        location: '青森県・十和田市',
        valid: true,
        coordinates: {
          pc: {
            x: '66.6%',
            y: '29.9%',
          },
          sp: {
            x: '67%',
            y: '29%',
          },
        },
      },
      {
        name: 'blestoncourt',
        title: '軽井沢ホテルブレストンコート',
        link: 'https://blestoncourt.com/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000002',
        description: '新境地に浸る、水のジビエ',
        location: '長野県・軽井沢',
        valid: true,
        coordinates: {
          pc: {
            x: '55%',
            y: '60.6%',
          },
          sp: {
            x: '50.6%',
            y: '62%',
          },
        },
      },
      {
        name: 'aomoriya',
        title: '青森屋',
        link: 'https://hoshinoresorts.com/ja/hotels/aomoriya/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000101',
        description: 'ハネトが舞い、祭り気分最高',
        location: '青森県・三沢市',
        valid: true,
        coordinates: {
          pc: {
            x: '68%',
            y: '28.8%',
          },
          sp: {
            x: '69%',
            y: '28%',
          },
        },
      },
      {
        name: 'bandaisan',
        title: '磐梯山温泉ホテル',
        link: 'https://www.bandaisan.co.jp/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000004',
        description: '磐梯山を望む高原リゾート',
        location: '福島県・耶麻郡',
        valid: true,
        coordinates: {
          pc: {
            x: '61%',
            y: '53.5%',
          },
          sp: {
            x: '60.5%',
            y: '52%',
          },
        },
      },
      {
        name: 'iriomotejima',
        title: '西表島ホテル',
        link: 'https://iriomotehotel.com/index.html',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000125',
        description: '日本最後の秘境、イリオモテヤマネコの棲む島。',
        location: '沖縄県・八重山郡',
        valid: true,
        coordinates: {
          pc: {
            x: '1.4%',
            y: '87.0%',
          },
          sp: {
            x: '6.4%',
            y: '37.2%',
          },
        },
      },
      {
        name: '1955tokyobay',
        title: '1955 東京ベイ',
        link: 'https://hoshinoresorts.com/ja/hotels/1955tokyobay/',
        ygetsLink: 'https://hoshinoresorts.com/JA/hotels/0000000401',
        description: 'Oldies Goodies',
        location: '千葉県・浦安市',
        valid: true,
        coordinates: {
          pc: {
            x: '60.3%',
            y: '65.5%',
          },
          sp: {
            x: '57.9%',
            y: '65.3%',
          },
        },
      },
    ],
  },
];

export default brands;



// WEBPACK FOOTER //
// ./src/components/Home/constants/brands.js